<div class="storage-clear-section">
    <button type="button" class="action-btn" (click)="clearStorage()">Clear Storage</button>
</div>